<template>
  <b-card class="shadow atm-rounded">
    <section v-if="weekStats">
      <table class="w-100 table table-bordered">
        <thead>
          <tr>
            <th>
              <b-card-title>Weekly stats</b-card-title>
            </th>
            <th class="text-center">
              <b-img :src="coinImg" class="coinImg"></b-img>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Coins earned this week</td>
            <td class="text-center">{{ weekStats.weekEarnedCoins }}</td>
          </tr>
          <tr>
            <td>Average weekly coins</td>
            <td class="text-center">{{ weekStats.currentWeeklyAverage }}</td>
          </tr>
          <tr>
            <td>Best week</td>
            <td class="text-center">{{ weekStats.bestWeek.weekCoins }}</td>
          </tr>
        </tbody>
      </table>
    </section>
  </b-card>
</template>

<script>
export default {
  props: {
    currentWeekStats: Object,
  },
  data() {
    return {
      coinImg: require('@/assets/coin2.png'),
      weekStats: null,
    };
  },
  watch: {
    currentWeekStats: {
      handler(newVal) {
        if (newVal) this.weekStats = newVal;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
